// eslint-disable-next-line import/no-anonymous-default-export
export default 'DUCKS/AIRPORT_SHUTTLES_GUIDES';
